"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/ui/components");
var _vuex = require("vuex");
var _constants = require("@/config/constants");
var _moment = _interopRequireDefault(require("moment"));
var _validators = require("vuelidate/lib/validators");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ModalPesagem',
  components: {
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isFetching: false,
      productId: null,
      idItem: null,
      listTypesCustomFields: _constants.LIST_CUSTOM_FIELDS,
      listClientes: [],
      listProducts: [],
      listServices: [],
      stepsFinishedsData: [],
      selectedService: {},
      listTypePayments: [{
        id: 'avista',
        description: 'A vista'
      }, {
        id: 'parcelado',
        description: 'Parcelado'
      }],
      form: {
        clientId: null,
        serviceId: null,
        glebe: null,
        plot: [],
        harvestDate: null,
        note: '',
        status: '',
        type: null,
        name: '',
        address: '',
        city: '',
        identificationDocument: '',
        paymentConditions: ''
      },
      formSell: {
        product: '',
        productId: null,
        varietyId: null,
        cultivationId: null,
        qtd: 0,
        kg: '',
        boxType: '',
        price1: '',
        price2: '',
        price3: '',
        packaging: '',
        total: 0,
        packingListId: null,
        offValue: 0,
        percent1: null,
        percent2: null,
        percent3: null
      },
      options: [{
        name: '',
        value: '',
        order: null
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listCustomers', 'allPlots'])), {}, {
    dateCreated: function dateCreated() {
      var date = (0, _moment.default)().toISOString();
      return this.idItem ? this.item.createdAt : date;
    },
    title: function title() {
      return this.idItem ? 'Edição de Pesagem - ' : 'Pesagem';
    },
    isContainOptions: function isContainOptions() {
      return _constants.LIST_CUSTOM_FIELDS_OPTIONS.includes(this.form.type);
    },
    isEditable: function isEditable() {
      return !!this.idItem;
    },
    price1: function price1() {
      if (this.formSell.percent1 && this.formSell.price1) {
        return (Number(this.formSell.percent1) * Number(this.formSell.price1)).toFixed(2);
      }
      return 0;
    },
    price2: function price2() {
      if (this.formSell.percent2 && this.formSell.price2) {
        return (Number(this.formSell.percent2) * Number(this.formSell.price2)).toFixed(2);
      }
      return 0;
    },
    price3: function price3() {
      if (this.formSell.percent3 && this.formSell.price3) {
        return (Number(this.formSell.percent3) * Number(this.formSell.price3)).toFixed(2);
      }
      return 0;
    },
    total: function total() {
      return Number(this.price1) + Number(this.price2) + Number(this.price3) - this.formSell.offValue;
    },
    kg: function kg() {
      if (this.formSell.qtd) {
        return Number(this.formSell.qtd) * 22;
      }
      return 0;
    },
    listVarieties: function listVarieties() {
      var _this = this;
      if (!this.formSell.productId) return [];
      var data = this.listProducts.find(function (item) {
        return item.id === _this.formSell.productId;
      });
      return data && data.varieties ? data.varieties : [];
    },
    listCultivations: function listCultivations() {
      var _this2 = this;
      if (!this.formSell.varietyId) return [];
      var data = this.listVarieties.find(function (item) {
        return item.id === _this2.formSell.varietyId;
      });
      return data ? data.cultivations : [];
    }
  }),
  watch: {
    productId: function productId(val) {
      if (val) {
        this.$v.formSell.productId.$model = val;
      }
    }
  },
  created: function created() {
    this.loadCustomers();
    this.loadProducts();
    this.fetchPlots();
    if (this.item.id) {
      this.idItem = this.item.id;
      this.form = _lodash.default.cloneDeep(this.item);
      this.getData(this.item.id);
    }
  },
  validations: {
    form: {
      clientId: {
        required: _validators.required
      },
      serviceId: {},
      glebe: {},
      plot: [],
      harvestDate: {},
      note: {},
      status: {},
      type: {},
      name: {},
      address: {},
      city: {},
      identificationDocument: {},
      paymentConditions: {}
    },
    formSell: {
      product: {},
      productId: {
        required: _validators.required
      },
      varietyId: {},
      cultivationId: {},
      qtd: {
        required: _validators.required
      },
      kg: {},
      boxType: {},
      price: {
        required: _validators.required
      },
      packaging: {},
      total: 0,
      packingListId: {},
      offValue: 0,
      percent1: {},
      percent2: {},
      percent3: {}
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getCustomFieldItem', 'createCustomField', 'editCustomField', 'deleteOptionCustomField', 'fetchProducts', 'fetchClassifications', 'fetchCustomers', 'fetchPlots', 'createNewRomaneio', 'updateRomaneio', 'fetchDetailRomaneio', 'fetchServices', 'fetchValuesCFStepsFinisheds', 'fetchListRomaneio'])), {}, {
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _this3 = this;
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchDetailRomaneio(id);
            case 1:
              data = _context.v;
              if (data.product) {
                this.productId = data.product.productId;
                Object.keys(data.product).map(function (key) {
                  if (data.product[key]) _this3.formSell[key] = data.product[key];
                });
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData(_x) {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    resolved: function () {
      var _resolved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
        var payload;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              e.preventDefault();
              this.$v.form.$touch();
              if (!(this.$v.form.$invalid || this.isContainOptions)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              }));
            case 1:
              payload = {
                package: this.form,
                products: _objectSpread(_objectSpread({}, this.formSell), {}, {
                  kg: this.kg,
                  total: this.total,
                  price1: this.price1,
                  price2: this.price2,
                  price3: this.price3
                })
              };
              if (this.form.harvestDate) payload.package.harvestDate = (0, _moment.default)(this.form.harvestDate).format('DD/MM/YYYY');
              this.$parent.close();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function resolved(_x2) {
        return _resolved.apply(this, arguments);
      }
      return resolved;
    }(),
    cancelModal: function cancelModal() {
      this.$parent.close();
    },
    loadProducts: function () {
      var _loadProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fetchProducts();
            case 1:
              this.listProducts = _context3.v;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadProducts() {
        return _loadProducts.apply(this, arguments);
      }
      return loadProducts;
    }(),
    loadCustomers: function () {
      var _loadCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.fetchCustomers();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function loadCustomers() {
        return _loadCustomers.apply(this, arguments);
      }
      return loadCustomers;
    }(),
    openModalNewCustomer: function openModalNewCustomer() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalNewCustomer,
        hasModalCard: true,
        customClass: 'modal-new-tag-template-customer',
        canCancel: ['escape'],
        props: {
          action: this.loadCustomers
        }
      });
    },
    readWeight: function readWeight() {
      console.log('ler dados...');
    },
    getAsyncData: function () {
      var _getAsyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(name) {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.isFetching = true;
              _context5.n = 1;
              return this.fetchServices({
                status: 'FINISHED',
                name: name
              });
            case 1:
              data = _context5.v;
              if (data) {
                this.listServices = data;
              }
              this.isFetching = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getAsyncData(_x3) {
        return _getAsyncData.apply(this, arguments);
      }
      return getAsyncData;
    }(),
    selectService: function () {
      var _selectService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(item) {
        var steps, data, totalCaixas, _iterator, _step, step;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.selectedService = item;
              this.form.serviceId = item.id;
              if (!(item.stepsCompleted && item.stepsCompleted.length)) {
                _context6.n = 2;
                break;
              }
              steps = item.stepsCompleted.map(function (i) {
                return i.id;
              });
              _context6.n = 1;
              return this.fetchValuesCFStepsFinisheds({
                steps: steps
              });
            case 1:
              data = _context6.v;
              if (data && data.length) {
                this.stepsFinishedsData = data;
                totalCaixas = 0; // COLHEITA BEST FRUIT
                _iterator = _createForOfIteratorHelper(data);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    step = _step.value;
                    if (step.customField && step.customField.name === 'COLHEITABESTFRUIT01') {
                      this.formSell.percent1 += Number(step.customFieldValue);
                      totalCaixas += parseFloat(step.customFieldValue);
                    }
                    if (step.customField && step.customField.name === 'COLHEITABESTFRUIT02') {
                      this.formSell.percent2 += Number(step.customFieldValue);
                      totalCaixas += parseFloat(step.customFieldValue);
                    }
                    if (step.customField && step.customField.name === 'COLHEITABESTFRUIT03') {
                      this.formSell.percent3 += Number(step.customFieldValue);
                      totalCaixas += parseFloat(step.customFieldValue);
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.formSell.qtd = totalCaixas;
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function selectService(_x4) {
        return _selectService.apply(this, arguments);
      }
      return selectService;
    }()
  })
};